// Channel endpoints
export const GET_CONNECTED_CHANNELS_URL = "/unipile/channels";
export const CONNECT_CHANNEL_URL = "/unipile/channels/connect";
export const DISCONNECT_CHANNEL_URL = "/unipile/channels/disconnect";
export const RECONNECT_CHANNEL_URL = "/unipile/channels/:id/reconnect";
export const CHECK_ACCOUNT_STATUS_URL = "/unipile/accounts/:accountId/check-status";

// Chat endpoints
export const GET_CONVERSATIONS_URL = "/unipile/chats";
export const GET_CHAT_BY_CONTACT_URL = "/unipile/chats/by-contact";
export const GET_CONVERSATION_URL = "/unipile/chats/:id";
export const GET_CONVERSATION_MESSAGES_URL = "/unipile/chats/:id/messages";
export const SEND_MESSAGE_URL = "/unipile/chats/:id/messages";
export const CREATE_CHAT_URL = "/unipile/chats";
export const PATCH_CHAT_URL = "/unipile/chats/:id"; // Perform action on chat
export const SYNC_CHAT_URL = "/unipile/chats/:id/sync";
export const SYNC_ALL_MESSAGES_URL = "/unipile/chats/sync-all";
export const GET_CHAT_ATTENDEES_URL = "/unipile/chats/:id/attendees";

// Message endpoints
export const GET_ALL_MESSAGES_URL = "/unipile/messages";
export const GET_MESSAGE_URL = "/unipile/messages/:id";
export const DELETE_MESSAGE_URL = "/unipile/messages/:id";
export const FORWARD_MESSAGE_URL = "/unipile/messages/:id/forward";
export const ADD_MESSAGE_REACTION_URL = "/unipile/messages/:id/reactions";
export const REMOVE_MESSAGE_REACTION_URL = "/unipile/messages/:id/reactions";
export const GET_MESSAGE_ATTACHMENT_URL =
  "/unipile/messages/:message_id/attachments/:attachment_id";

// Attendee endpoints
export const GET_ALL_ATTENDEES_URL = "/unipile/chat_attendees";
export const GET_ATTENDEE_URL = "/unipile/chat_attendees/:id";
export const GET_ATTENDEE_PICTURE_URL = "/unipile/chat_attendees/:id/picture";
export const GET_ATTENDEE_CHATS_URL = "/unipile/chat_attendees/:attendee_id/chats";
export const GET_ATTENDEE_MESSAGES_URL = "/unipile/chat_attendees/:sender_id/messages";

// Email endpoints
export const GET_EMAILS_URL = "/unipile/emails";
export const SEND_EMAIL_URL = "/unipile/emails";
export const GET_EMAIL_URL = "/unipile/emails/:id";
export const DELETE_EMAIL_URL = "/unipile/emails/:id";
export const UPDATE_EMAIL_URL = "/unipile/emails/:id";
export const UPDATE_THREAD_URL = "/unipile/emails/thread/:thread_id";
export const DELETE_THREAD_URL = "/unipile/emails/thread/:thread_id";
export const GET_EMAIL_ATTACHMENT_URL = "/unipile/emails/:email_id/attachments/:attachment_id";
export const GET_EMAIL_READ_RECEIPTS_URL = "/unipile/emails/:email_id/read-receipts";
export const UPLOAD_EMAIL_ATTACHMENT_URL = "/unipile/upload-attachment";

// Folder endpoints
export const GET_FOLDERS_URL = "/unipile/folders";
export const GET_FOLDER_URL = "/unipile/folders/:id";

// Draft endpoints
export const CREATE_DRAFT_URL = "/unipile/drafts";

// User endpoints
export const GET_INVITATIONS_SENT_URL = "/unipile/users/invitations/sent";
export const GET_INVITATIONS_RECEIVED_URL = "/unipile/users/invitations/received";
export const HANDLE_INVITATION_RECEIVED_URL = "/unipile/users/invitations/received/:invitation_id";
export const GET_OWN_PROFILE_URL = "/unipile/users/me";
export const EDIT_OWN_PROFILE_URL = "/unipile/users/me/edit";
export const GET_RELATIONS_URL = "/unipile/users/relations";
export const CHECK_CONNECTION_STATUS_URL = "/unipile/users/relations/check";
export const CHECK_CONNECTION_STATUS_BY_CONTACT_URL = "/unipile/users/relations/check-by-contact";
export const GET_FOLLOWING_URL = "/unipile/users/following";
export const GET_FOLLOWERS_URL = "/unipile/users/followers";
export const GET_PROFILE_URL = "/unipile/users/:identifier";
export const SEND_INVITATION_URL = "/unipile/users/invite";
export const GET_POSTS_URL = "/unipile/users/:identifier/posts";
export const GET_COMMENTS_URL = "/unipile/users/:identifier/comments";
export const GET_REACTIONS_URL = "/unipile/users/:identifier/reactions";
export const CANCEL_INVITATION_URL = "/unipile/users/invitations/sent/:invitation_id";

// LinkedIn Search endpoints
export const LINKEDIN_SEARCH_URL = "/unipile/linkedin/search";
export const LINKEDIN_SEARCH_BROWSE_URL = "/unipile/linkedin/search/browse";
export const LINKEDIN_SEARCH_IMPORT_URL = "/unipile/linkedin/search/import";

// LinkedIn Company Profile endpoint
export const GET_COMPANY_PROFILE_URL = "/unipile/linkedin/company/:identifier";
